import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * Tag: short label such as "Collect cash", "1 ticket", "Restock & repair".
 * Props:
 * - label (string)
 * - tone: 'neutral' | 'warning' (e.g. Coins required) | 'success' | 'danger' | 'primary'
 * - size: 'small' (run list rows) | 'regular' (stop screen header)
 * - style
 */
const Tag = ({ label, tone = 'neutral', size = 'small', style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[styles.tag, styles[size], styles[tone], style]}>
			<Text style={[styles.label, styles[`${tone}Label`]]} numberOfLines={1}>{label}</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, type } }) => ({
	tag: {
		alignSelf: 'flex-start',
		backgroundColor: colors.tag,
	},
	small: {
		borderRadius: radius.tag,
		paddingVertical: 3,
		paddingHorizontal: 7,
	},
	regular: {
		borderRadius: radius.chip,
		paddingVertical: 6,
		paddingHorizontal: 10,
		backgroundColor: colors.chip,
	},
	label: {
		...type.tag,
		color: colors.onChip,
	},
	neutral: {},
	neutralLabel: {},
	warning: {
		backgroundColor: colors.warningTagBg,
	},
	warningLabel: {
		...type.label,
		color: colors.warning,
	},
	success: {
		backgroundColor: colors.successBg,
	},
	successLabel: {
		color: colors.onSuccessBg,
	},
	danger: {
		backgroundColor: colors.dangerSolid,
	},
	dangerLabel: {
		color: colors.onDangerSolid,
	},
	primary: {
		backgroundColor: colors.primary,
	},
	primaryLabel: {
		...type.label,
		color: colors.onPrimary,
	},
});

export default Tag;
